/** Availability check for a project's custom domain (GET /projects/check-domain).
 *  Pass `projectId` when editing so the project's own domain is not reported
 *  as a collision with itself. */
import api from '../utils/axios';

export interface ProjectDomainAvailability {
  available: boolean;
  reason?: string | null;
}

export async function checkProjectDomain(
  domain: string,
  projectId?: string
): Promise<ProjectDomainAvailability> {
  const response = await api.get('/projects/check-domain', {
    params: {
      domain,
      ...(projectId ? { project_id: projectId } : {}),
    },
  });
  return response.data;
}
